module.exports = __webpack_public_path__ + "static/img/desc.c9e2d543.png";